import Actions                from 'Redux/Actions';
import { EmployeeRepository } from 'Domain/Repositories';
import { ofType }             from 'redux-observable';
import { from, EMPTY }        from 'rxjs';
import { mergeMap }           from 'rxjs/operators';
import { TEpic }              from 'Redux/Config';

export const findEmployeeEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEmployeeRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        EmployeeRepository.findById(id)
          .then((employee) => Actions.findEmployeeSuccess({ employee }))
          .catch(error => Actions.findEmployeeFailure({ error })),
      );
    }),
  );
};
